import { render, staticRenderFns } from "./QmpKeyboard.vue?vue&type=template&id=2a723049&scoped=true&"
import script from "./QmpKeyboard.vue?vue&type=script&lang=js&"
export * from "./QmpKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./QmpKeyboard.vue?vue&type=style&index=0&id=2a723049&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a723049",
  null
  
)

export default component.exports